// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__3aS72","footer":"styles_footer__3gzZz"};